import React, { useState } from "react";
import { API_BASE_URL } from "../../config.tsx";
import apiFetch, { deleteHeadset } from "../helpers/requests"; // Import deleteHeadset
import "../../styles/admin.css";
import { useTranslation } from "react-i18next";

const ConfirmDeleteHeadsetModal = ({
  setShowConfirmDeleteHeadsetModal,
  licenseId, // This is now the licenseId from the headset
  headsetId, // New prop for the headset ID
  headsetName, // This is the deviceId string
  handleDeleteHeadsetSubmit,
}) => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleDeleteHeadsetClick = async (headsetId: string | null, licenseId: string | null) => {
    setIsLoading(true);
    try {
      await deleteHeadset(headsetId); // Call the renamed deleteHeadset API
      setShowConfirmDeleteHeadsetModal(false);
      handleDeleteHeadsetSubmit();
    } catch (error) {
      console.error("Error deleting headset:", error);
      alert(t("An_error_occurred_while_deleting_the_headset")); // Show generic error
      setIsLoading(false);
    }
  };

  return (
    <div className="confirmation-modal">
      <div className="modal-content">
        <div
          style={{ textAlign: "center", fontSize: "1.3em", marginTop: "2vh" }}
        >
          {t("Confirm_to_delete_headset")}
        </div>
        <label style={{ lineHeight: "1", marginTop: "2vh" }}>
          {t("This_is_irreversible_action.")}
          <br />
          {t("The_headset_will_be_removed_from_system")}
        </label>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "5vh",
            maxHeight: "1%",
          }}
        >
          <div className="userDataWrapper">
            {headsetName}
          </div>
        </div>

        <div className="button-container">
          <button
            type="button"
            className="buttonCancel btn btn-primary"
            disabled={isLoading}
            onClick={() => setShowConfirmDeleteHeadsetModal(false)}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="buttonAccept btn btn-primary"
            disabled={isLoading}
            onClick={() => handleDeleteHeadsetClick(headsetId, licenseId)}
          >
            {isLoading ? t("Loading...") : t("Delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteHeadsetModal;